import { Component, inject, signal } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { HlmPopoverImports } from '@spartan-ng/helm/popover';
import {
  SUPPORTED_LANGUAGES,
  SUPPORTED_LANGUAGE_CODES,
  LanguageOption,
  LanguagePreferenceService,
} from 'shared';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

@Component({
  selector: 'ocp-language-switcher',
  imports: [HlmPopoverImports, UpperCasePipe, TranslatePipe, ThemedIconComponent],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss',
})
export class LanguageSwitcherComponent {
  private readonly translateService = inject(TranslateService);
  private readonly languagePreference = inject(LanguagePreferenceService);

  readonly languages: LanguageOption[] = SUPPORTED_LANGUAGE_CODES.map(code => ({
    code,
    name: SUPPORTED_LANGUAGES[code],
  }));

  readonly selectedLanguage = signal<LanguageOption>(
    this.languages.find(l => l.code === this.translateService.getCurrentLang()) ?? this.languages[0]
  );

  readonly isPopoverOpen = signal(false);
  readonly popoverId = 'language-switcher-popover';

  onLanguageChange(lang: LanguageOption, ctx: { close: () => void }): void {
    this.translateService.use(lang.code);
    this.languagePreference.savePreference(lang.code);
    this.selectedLanguage.set(lang);
    ctx.close();
  }

  onStateChanged(state: string): void {
    this.isPopoverOpen.set(state === 'open');
  }
}
